import React, { useRef, useState, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as appActions from "../../core/app.store";
import * as config from '../../common/config'

import headCellsListTransportOrder from './head-cell-list-transport-order';
import DataTableSarang from '../../components/datatable-sarang';
import { getCookies, getUserInfo } from "../../utils/configuration";

import * as transportOrderManagementAction from "../../redux/store-sarang/transport-order/transport-order-management.store";
import styles from './custome-style.module.scss'
import FormSearchWrapperSarang from '../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import { useMediaQuery } from 'react-responsive';
import MobileHeaderSarang from '../../components/mobile-header/mobile-header-sarang';
import DataTablePagination from '../../components/datatable-sarang/datatable-pagination';

import { useLookupHerdsman } from '../../hooks/useLookupHerdsman';
import { useLookupDepartment } from '../../hooks/useLookupDepartment';
import { useLookupBranch } from '../../hooks/useLookupBranch';
import { useTransportOrderData } from './hooks/useTransportOrderData';
import { useTransportOrderActions } from './hooks/useTransportOrderActions';
import { useTransportOrderNotifications } from './hooks/useTransportOrderNotifications';
import { TransportOrderSearchForm } from './components/TransportOrderSearchForm';
import { TransportOrderModals } from './components/TransportOrderModals';
import { TransportOrderTableDesktop, TransportOrderTableMobile } from './components/TransportOrderTable';

const configLocal = {
    defaultPageSize: config.Configs.DefaultPageSize,
    sortExpression: "orderDate desc" + (new Date().getHours() <= 13 ? ', receiptTime asc, commune.District.Name asc, commune.Name asc' : ', receiptTime desc, commune.District.Name asc, commune.Name asc'),
    orderBy: "orderDate",
    order: "desc",
}

export default function TransportOrderList() {
    const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1024px)" });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1023px)" });
    const dispatch = useDispatch();
    const showLoading = (data) => dispatch(appActions.ShowLoading(data));
    // Hôm nay theo lịch Việt Nam (nửa đêm local) để mặc định "Từ ngày" không bị lệch múi giờ máy
    const [now] = useState(dayjs(dayjs().tz().format('YYYY-MM-DD')));
    const [currentUser] = useState(getUserInfo());
    const deviceId = getCookies('DeviceId');

    const { register, handleSubmit, setValue, control, getValues, reset } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
        defaultValues: {
            orderFromDate: dayjs(now).format("YYYY-MM-DD"),
            orderToDate: null,
            branchId: currentUser?.branchId || null,
            departmentId: null,
            herdsmanReceiptId: null,
            status: null
        }
    });

    const { herdsman, herdsmanAll, getLookupHerdsmanGV, getLookupHerdsmanAll } = useLookupHerdsman();
    const { departmentAll: department, getLookupDepartment } = useLookupDepartment();
    const { branch, getLookupBranch } = useLookupBranch();

    const {
        data, setData, totalItemCount, page, setPage, rowsPerPage, setRowsPerPage,
        order, setOrder, orderBy, setOrderBy, searchData, setSearchData,
        sumaryCuisine, getListTransportOrderManagement, getUserDetail
    } = useTransportOrderData(showLoading, configLocal, setValue, getValues);

    const buttonOpenAddEditRef = useRef();
    const buttonOpenConfirmRef = useRef();
    const buttonOpenConfirmCreateCuisineRef = useRef();

    const actions = useTransportOrderActions({
        showLoading, getListTransportOrderManagement, page, rowsPerPage, orderBy, order, searchData,
        deviceId, currentUser, // Use the defined currentUser state
        buttonOpenAddEditRef, buttonOpenConfirmRef, buttonOpenConfirmCreateCuisineRef
    });

    useTransportOrderNotifications({
        deviceId, setData, orderBy, order, page, rowsPerPage, searchData, getListTransportOrderManagement
    });

    useEffect(() => {
        getUserDetail();
        getLookupHerdsmanGV();
        getLookupHerdsmanAll();
        getLookupDepartment();
        getLookupBranch();
    }, []);

    const [openSearch, setOpenSearch] = useState(false);

    const onSubmit = useCallback((data) => {
        setSearchData(data);
        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        setPage(0);
        getListTransportOrderManagement(1, rowsPerPage, sortExpression, data);
        if (isTabletOrMobile) setOpenSearch(false);
    }, [orderBy, order, rowsPerPage, getListTransportOrderManagement, isTabletOrMobile]);

    const handleRequestSort = useCallback((event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const sortExpression = property + ' ' + newOrder + ((property && property !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
    }, [orderBy, order, page, rowsPerPage, searchData, getListTransportOrderManagement]);

    const handleChangePage = useCallback((newPage) => {
        setPage(newPage - 1);
        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        getListTransportOrderManagement(newPage, rowsPerPage, sortExpression, searchData);
    }, [orderBy, order, rowsPerPage, searchData, getListTransportOrderManagement]);

    const handleChangeRowsPerPage = useCallback((event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        const sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? ', receiptTime asc' : '') + ', commune.District.Name asc, commune.Name asc';
        getListTransportOrderManagement(1, newRowsPerPage, sortExpression, searchData);
    }, [orderBy, order, searchData, getListTransportOrderManagement]);

    const handleClearFilter = useCallback(() => {
        const initialStates = {
            orderFromDate: dayjs(now).format("YYYY-MM-DD"),
            orderToDate: null,
            branchId: currentUser?.branchId || null,
            departmentId: null,
            herdsmanReceiptId: null,
            status: null
        };
        reset(initialStates);
        onSubmit(initialStates);
    }, [now, reset, onSubmit, currentUser]);

    const renderSearchForm = useCallback(() => (
        <FormSearchWrapperSarang isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} hideNewButton={true}>
            <TransportOrderSearchForm
                handleSubmit={handleSubmit} onSubmit={onSubmit} register={register}
                setValue={setValue} now={now} control={control} branch={branch}
                department={department} herdsmanAll={herdsmanAll}
                handleClearFilter={handleClearFilter}
            />
        </FormSearchWrapperSarang>
    ), [isTabletOrMobile, openSearch, handleSubmit, onSubmit, register, setValue, now, control, branch, department, herdsmanAll, handleClearFilter]);

    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                {renderSearchForm()}

                {isDesktopOrLaptop && (
                    <TransportOrderTableDesktop
                        data={data} sumaryCuisine={sumaryCuisine} rowsPerPage={rowsPerPage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        headCellsListTransportOrder={headCellsListTransportOrder}
                        handleRequestSort={handleRequestSort} order={order} orderBy={orderBy}
                        totalItemCount={totalItemCount} setRowsPerPage={setRowsPerPage}
                        page={page} handleChangePage={handleChangePage} configLocal={configLocal}
                        getListTransportOrderManagement={getListTransportOrderManagement}
                        searchData={searchData} currentUser={currentUser}
                        herdsman={herdsman} setOpenChangeStatusDialog={actions.setOpenChangeStatusDialog}
                        openConfirmDialog={actions.openConfirmDialog}
                        openChangeDeliveryDialog={actions.openChangeDeliveryDialog}
                        setOpenCancelDeliveryDialog={actions.setOpenCancelDeliveryDialog}
                        setOpenAssignToMeDialog={actions.setOpenAssignToMeDialog}
                        setOpenAssignDeliveryDialog={actions.setOpenAssignDeliveryDialog}
                        styles={styles} DataTableSarang={DataTableSarang}
                    />
                )}

                {isTabletOrMobile && (
                    <TransportOrderTableMobile
                        data={data} totalItemCount={totalItemCount} rowsPerPage={rowsPerPage}
                        page={page} handleChangePage={handleChangePage}
                        headCellsListTransportOrder={headCellsListTransportOrder}
                        getListTransportOrderManagement={getListTransportOrderManagement}
                        searchData={searchData} setOrder={setOrder} setOrderBy={setOrderBy}
                        configLocal={configLocal} sumaryCuisine={sumaryCuisine}
                        currentUser={currentUser} herdsman={herdsman}
                        setOpenChangeStatusDialog={actions.setOpenChangeStatusDialog}
                        openConfirmDialog={actions.openConfirmDialog}
                        openChangeDeliveryDialog={actions.openChangeDeliveryDialog}
                        setOpenCancelDeliveryDialog={actions.setOpenCancelDeliveryDialog}
                        setOpenAssignToMeDialog={actions.setOpenAssignToMeDialog}
                        setOpenAssignDeliveryDialog={actions.setOpenAssignDeliveryDialog}
                        styles={styles} MobileHeaderSarang={MobileHeaderSarang}
                        DataTablePagination={DataTablePagination}
                    />
                )}
            </div>

            <TransportOrderModals
                buttonOpenAddEditRef={buttonOpenAddEditRef}
                buttonOpenConfirmRef={buttonOpenConfirmRef}
                buttonOpenConfirmCreateCuisineRef={buttonOpenConfirmCreateCuisineRef}
                isOpenAddEditDialog={actions.isOpenAddEditDialog}
                closeAddEditDialog={actions.closeAddEditDialog}
                herdsman={herdsman}
                selectedItem={actions.selectedItem}
                handleSubmitChangeDelivery={actions.handleSubmitChangeDelivery}
                isOpenDeleteDialog={actions.isOpenDeleteDialog}
                isOpenActiveDialog={actions.isOpenActiveDialog}
                isOpenDeactiveDialog={actions.isOpenDeactiveDialog}
                isOpenChangeStatusDialog={actions.isOpenChangeStatusDialog}
                isOpenAssignToMeDialog={actions.isOpenAssignToMeDialog}
                isOpenAssignDeliveryDialog={actions.isOpenAssignDeliveryDialog}
                isOpenCancelDeliveryDialog={actions.isOpenCancelDeliveryDialog}
                closeConfirmDialog={actions.closeConfirmDialog}
                handleConfirm={actions.handleConfirm}
                isOpenCreateCusineDialog={actions.isOpenCreateCusineDialog}
                closeConfirmCreateCuisineDialog={actions.closeConfirmCreateCuisineDialog}
                assignDelivery={actions.assignDelivery}
            />
        </div>
    )
}